module.exports = __webpack_public_path__ + "img/Loose Stones.2a4e726e.png";